export { default } from './WindHourReading';
